/**
 * Desktop-only sidebar icon-rail collapse toggle (#2579, EPIC #2575 Tier 4).
 *
 * A chevron button in the sidebar footer that flips the `w-64` ↔ `w-16` icon
 * rail. It is `hidden lg:inline-flex` — the rail is a desktop power-user
 * affordance only; on mobile the sidebar is the off-canvas drawer and this
 * toggle is not shown. ≥44px touch target, aria-pressed + aria-label track the
 * collapsed state, and the chevron rotates to point the direction it will move.
 */
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

interface SidebarCollapseToggleProps {
  collapsed: boolean;
  onToggle: () => void;
}

export function SidebarCollapseToggle({
  collapsed,
  onToggle,
}: SidebarCollapseToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={collapsed}
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar to icons"}
      title={collapsed ? "Expand sidebar" : "Collapse sidebar to icons"}
      className="hidden lg:inline-flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg text-gray-400 hover:bg-navy-light hover:text-[#ffffff] transition-colors"
    >
      {collapsed ? (
        <PanelLeftOpen className="h-5 w-5" />
      ) : (
        <PanelLeftClose className="h-5 w-5" />
      )}
    </button>
  );
}
